enum EHeaderSize {
  H1 = 1,
  H2 = 2,
  H3 = 3,
  H4 = 4,
}

export default EHeaderSize;
